(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sv-cart-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
  function addBusinessDays(startDate, businessDays) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var added = 0;
    while (added < businessDays) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return date;
  }

  function renderCartDelivery() {
    var locale = document.documentElement.lang || navigator.language || 'de-DE';
    var formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
    var today = new Date();

    document.querySelectorAll('[data-sv-cart-delivery]').forEach(function (element) {
      var minDays = parseInt(element.dataset.minBusinessDays, 10);
      var maxDays = parseInt(element.dataset.maxBusinessDays, 10);
      var target = element.querySelector('[data-sv-cart-delivery-range]');
      if (!target || Number.isNaN(minDays) || Number.isNaN(maxDays)) return;

      var earliest = addBusinessDays(today, minDays);
      var latest = addBusinessDays(today, maxDays);
      target.textContent = formatter.format(earliest) + ' – ' + formatter.format(latest);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCartDelivery);
  } else {
    renderCartDelivery();
  }
  document.addEventListener('shopify:section:load', renderCartDelivery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-delivery-trust"] && !Shopify.designMode) return;
  try {
    function svAddBusinessDays(startDate, businessDays) {
  var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  var added = 0;
  while (added < businessDays) {
    date.setDate(date.getDate() + 1);
    var day = date.getDay();
    if (day !== 0 && day !== 6) added += 1;
  }
  return date;
}

function svRenderDeliveryEstimates() {
  var locale = document.documentElement.lang || navigator.language || 'de-DE';
  var formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
  var today = new Date();

  document.querySelectorAll('.sv-delivery-estimate[data-min-business-days]').forEach(function (element) {
    var minDays = parseInt(element.dataset.minBusinessDays, 10);
    var maxDays = parseInt(element.dataset.maxBusinessDays, 10);
    var target = element.querySelector('[data-delivery-range]');
    if (!target || Number.isNaN(minDays) || Number.isNaN(maxDays)) return;

    var earliest = svAddBusinessDays(today, minDays);
    var latest = svAddBusinessDays(today, maxDays);
    target.textContent = formatter.format(earliest) + ' – ' + formatter.format(latest);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', svRenderDeliveryEstimates);
} else {
  svRenderDeliveryEstimates();
}
document.addEventListener('shopify:section:load', svRenderDeliveryEstimates);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-experience"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sv-personalizer'))customElements.define('sv-personalizer',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const options={signal:this.abort.signal};this.input=this.querySelector('input[type=file]');this.result=this.querySelector('.sv-upload-result');this.status=this.querySelector('[role=status]');this.form=document.getElementById(this.dataset.form);this.version=0;this.valid=false;this.input.addEventListener('change',()=>this.load(),options);this.querySelector('[data-remove]').addEventListener('click',()=>{this.clear();this.input.focus()},options);this.form?.addEventListener('submit',event=>{if(!this.valid){event.preventDefault();event.stopImmediatePropagation();this.message(this.dataset.empty,true);this.input.setCustomValidity(this.dataset.empty);this.input.reportValidity();this.input.focus()}},{...options,capture:true})}
 message(text,error=false){this.status.textContent=text;this.status.dataset.error=String(error)}
 clear(){this.version++;this.valid=false;this.input.value='';this.input.setCustomValidity('');this.result.hidden=true;this.querySelector('img').removeAttribute('src');if(this.url)URL.revokeObjectURL(this.url);this.url=null;this.message('')}
 async load(){const file=this.input.files[0];this.valid=false;this.result.hidden=true;this.input.setCustomValidity('');const version=++this.version;if(this.url)URL.revokeObjectURL(this.url);this.url=null;if(!file)return this.message('');if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>20971520){this.input.value='';this.message(this.dataset.invalid,true);return}this.message(this.dataset.busy);const url=URL.createObjectURL(file);this.url=url;const img=new Image();try{img.src=url;await img.decode();if(version!==this.version)return;if(img.naturalWidth*img.naturalHeight>50000000)throw Error('size');this.querySelector('img').src=url;this.querySelector('[data-filename]').textContent=file.name;this.valid=true;this.result.hidden=false;this.message(this.dataset.ready)}catch(error){if(version!==this.version)return;this.input.value='';this.message(this.dataset.invalid,true)}}
 disconnectedCallback(){this.version++;this.abort?.abort();if(this.url)URL.revokeObjectURL(this.url);this.ready=false}
});
if(!customElements.get('sv-sticky'))customElements.define('sv-sticky',class extends HTMLElement{connectedCallback(){this.target=document.querySelector('.product-form__submit');if(!this.target)return;this.observer=new IntersectionObserver(entries=>{this.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0},{threshold:0});this.observer.observe(this.target)}disconnectedCallback(){this.observer?.disconnect()}});
  } catch(e) { console.error(e); }
})();

})();
